import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import QuoteDataService from "../services/Quote.services";
import CircularProgress from "@mui/material/CircularProgress";

export default function QuotePicker(props) {
    const [value, setValue] = React.useState(null);
    const [quotes, setQuotes] = React.useState([]);
    const [inputValue, setInputValue] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);

    const { handleChangeQuote, errors } = props;
    const { editing, editObject } = props;

    React.useEffect(() => {
        if (editing && editObject && editObject.quote) {
            handleInputValue(editObject.quote);
        }
    }, [editing]);

    // Debounced search
    React.useEffect(() => {
        if (inputValue.trim().length < 2) {
            if (inputValue.length === 0 && !value) {
                setQuotes([]);
            }
            return;
        }

        const timeoutId = setTimeout(() => {
            searchQuotes(inputValue);
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [inputValue, value]);

    const searchQuotes = (query) => {
        setIsLoading(true);
        QuoteDataService.searchAll(props.token, query)
            .then((response) => {
                setQuotes(response.data);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleInputValue = (newValue) => {
        setValue(newValue);
        handleChangeQuote(newValue);
    };

    return (
        <Autocomplete
            disablePortal
            fullWidth
            autoSelect={false}
            blurOnSelect="touch"
            loading={isLoading}
            value={value}
            onChange={(event, newValue) => {
                if (newValue) {
                    setQuotes((prev) => {
                        const exists = prev.some((q) => q.id === newValue.id);
                        return exists ? prev : [newValue, ...prev];
                    });
                }
                handleInputValue(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            options={quotes}
            isOptionEqualToValue={(option, newValue) => {
                return option.id === newValue.id;
            }}
            getOptionLabel={(option) =>
                option.number ? `${option.number} ${option.name}` : ""
            }
            noOptionsText={
                inputValue.length < 2 ? "Type to search..." : "No quotes found"
            }
            renderInput={(params) => (
                <TextField
                    helperText={
                        errors.quote === null || errors.project === null
                            ? ""
                            : errors.quote || errors.project
                    }
                    error={errors.quote || errors.project ? true : false}
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {isLoading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    id="quote"
                    name="quote"
                    label={isLoading ? "Searching..." : "Search Quotes"}
                />
            )}
        />
    );
}
